import { ICardForm } from '@/interface';
import { AIGC_IMAGE_PROMPT_LENGTH, AiImageModel, AiImageModelType, AiImageResolution, AiType, DEFAULT_AI_IMAGE_MODEL } from '@/interface/aigc';
import { getUnicodeLength } from '@/utils/getUnicodeLength';

export const aigcImageFormCard1: ICardForm = {
  key: 'aigcImage',
  title: 'AI 智能绘图',
  fieldsConfig: [
    {
      props: 'model',
      label: '模型选择',
      render: 'select',
      className: 'aigc-select',
      uiOptions: {
        defaultValue: DEFAULT_AI_IMAGE_MODEL,
        options: [
          { ...AiImageModel.JIMENG_30 },
          { ...AiImageModel.JIMENG_31 },
        ],
      },
    },
    {
      props: 'text',
      className: 'aigc-text-prompt',
      notShowLabel: true,
      render: 'textareaImage',
      rules: [],
      uiOptions: {
        autosize: { minRows: 10, maxRows: 10 },
        maxlength: AIGC_IMAGE_PROMPT_LENGTH,
        placeholder: '请输入画面描述关键词，以逗号分割。\n\n如：天气晴朗，漂亮女生，乌黑秀发，明亮的大眼睛，穿着粉丝裙子，开心微笑，在公园散步',
        label: '画面描述',
        required: true,
        polish: true,
        type: AiType.IMAGE,
      },
    },
    {
      props: 'resolution',
      label: '清晰度',
      render: 'select',
      className: 'aigc-select',
      uiOptions: {
        defaultValue: AiImageResolution['1K'].value,
        options: [
          { ...AiImageResolution['1K'] },
          { ...AiImageResolution['2K'] },
        ],
      },
    },
    {
      props: 'style',
      label: '绘图风格',
      render: 'customAigcModel',
    },
  ],
};

const filterMj = [{
  key: 'model',
  value: [AiImageModelType.AI_IMAGE_MIDJOURNEY],
}];

// 高级设置
export const aigcImageFormCard2: ICardForm = {
  key: 'aigcImage',
  title: 'AI 智能绘图',
  fieldsConfig: [
    {
      props: 'cref',
      notShowLabel: true,
      render: 'customAigcImage',
      filter: filterMj,
      uiOptions: {
        label: '形象参考',
      },
    },
    {
      props: 'cw',
      label: '形象参考权重',
      render: 'customAigcNumber',
      filter: filterMj,
      uiOptions: {
        defaultValue: 100,
        min: 0,
        max: 100,
      },
    },
    {
      props: 'sref',
      notShowLabel: true,
      render: 'customAigcImage',
      filter: filterMj,
      uiOptions: {
        label: '风格参考',
      },
    },
    {
      props: 'sw',
      label: '风格参考权重',
      render: 'customAigcNumber',
      filter: filterMj,
      uiOptions: {
        defaultValue: 100,
        min: 0,
        max: 1000,
      },
    },
    {
      props: 'negativeText',
      label: '负向描述词',
      render: 'textarea',
      rules: [{ validator: e => getUnicodeLength(e) <= 800, message: '最多输入800字', type: 'error' }],
      uiOptions: {
        autosize: { minRows: 5, maxRows: 5 },
        maxlength: 800,
        placeholder: '输入不想出现在画面中的内容关键词，以逗号分割',
      },
    },
  ],
};
